
export interface GiftToneDto
{
    getMsisdnA(): string;
    getMsisdnB(): string;
    getLanguage(): string;
    getToneId(): string;
    getToneName(): string;
    getPackName(): string;
    getChannelId(): string;
    getUserName(): string;
}

export class GiftToneDtoImpl implements GiftToneDto
{
    private msisdnA: string;
    private msisdnB: string;
    private language: string;
    private toneId: string;
    private toneName: string;
    private packName: string;
    private channelId: string;
    private userName: string;

    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }
    getChannelId(): string 
    {
        return this.channelId;
    } 
    setUserName(userName: string)
    {
        this.userName = userName;
    }
    getUserName(): string {
       return this.userName;
    }
    getPackName(): string {
        return this.packName;
    }

    setPackName(packName: string): void
    {
        this.packName = packName;
    }
    getMsisdnA(): string 
    {
        return this.msisdnA;
    }
    setMsisdnA(msisdnA: string)
    {
        this.msisdnA = msisdnA;
    }

    getMsisdnB(): string 
    {
        return this.msisdnB;
    }
    setMsisdnB(msisdnB: string)
    {
        this.msisdnB = msisdnB;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getToneId(): string 
    {
        return this.toneId;
    }
    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }

    getToneName(): string 
    {
        return this.toneName;
    }
    setToneName(toneName: string)
    {
        this.toneName = toneName;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/gifttone/gifttonedto.tsx